/**
 * Reveal-on-Scroll — observes .rv and .afu elements
 * and adds .visible when they enter the viewport.
 */
document.addEventListener('DOMContentLoaded', function () {
    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.06, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.rv, .afu').forEach(function (el) {
        observer.observe(el);
    });
});
